import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { createStore } from '@aibees/shared/store';
import { ModalityChangeCounterStoreData as StoreData } from './types';

const useModalityChangeCounterStore = createStore<StoreData>(
  'modality-change-counter',
  (set) => ({
    counter: {
      [SearchModality.TOTAL]: `${SearchModality.TOTAL}-0`,
      [SearchModality.SAVED]: `${SearchModality.SAVED}-0`,
      [SearchModality.UNSAVED]: `${SearchModality.UNSAVED}-0`,
    },
    incrementCounter: (modality: SearchModality) =>
      set((state) => ({
        counter: {
          ...state.counter,
          [modality]: `${modality}-${
            Number(state.counter[modality].split('-')[1]) + 1
          }`,
        },
      })),
  })
);

export default useModalityChangeCounterStore;
